
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export default {
  install(Vue) {
    (Vue.prototype.$equals = function(str, comparison) {
      return str === comparison;
    }),
      (Vue.prototype.$dateTimeReviver = function(value) {
        var time = function(dt) {
          var year = dt.getFullYear();
          var month = dt.getMonth() + 1;
          var date = dt.getDate();
          var hour = dt.getHours();
          var minute = dt.getMinutes();
          var second = dt.getSeconds();
          return (
            year +
            '-' +
            month +
            '-' +
            date +
            ' ' +
            hour +
            ':' +
            minute +
            ':' +
            second
          );
        };
        var t = value.slice(6, 19);
        var NewDtime = new Date(parseInt(t));
        return time(NewDtime);
      });

    /** 获取url参数值
     * @param  {[string]} urlKey
     * @return {[string]} urlValue
     */
    Vue.prototype.$getUrlKey = function(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
      );
    };
    /** 隐藏中间几个字符用*代替
     * @param {[string]} 需要替换的字符
     * @return {[string]} 替换好的字符
     *  */
    Vue.prototype.$hideMiddle = function(val) {
      return `${val.substring(0, 3)}****${val.substring(val.length - 3)}`;
    };

    Vue.prototype.$getUA = function() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // anroid设备
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      // let isChrome = navigator.userAgent.indexOf('Chrome') > -1 // Chrome 调试
      if (isAndroid) {
        return 1;
      } else if (isiOS) {
        return 2;
      } else {
        return 3;
      }
    };

    Vue.prototype.$getIsApp = function() {
      let u = navigator.userAgent;
      let isApp = u.indexOf('Android_app') > -1 || u.indexOf('ios_app') > -1;
      // console.log('是否在App：', isApp);
      return isApp;
    };
    Vue.prototype.$getIsBsyq = function() {
      let u = navigator.userAgent;
      let isApp =
        u.indexOf('ios_bsyq') > -1 ||
        u.indexOf('bsyq,android') > -1 ||
        u.indexOf('ios_zyx') > -1;
      // console.log('是否在BSYQ：', isApp);
      return isApp;
    };

    Vue.prototype.$callApp = function(agent, method, params) {
      if (this.$getUA() === 1 && agent === 'Android') {
        if (window.control) {
          window.control[method](params);
        }
        return;
      }
      if (this.$getUA() === 2 && agent === 'iOS') {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers[method]['postMessage'](params);
        }
      }
    };
    /** 判断字符串是否为空
     * @param  { string }
     * @return { boolean }
     */
    Vue.prototype.$isEmpty = function(str) {
      if (typeof str !== 'undefined') {
        if (str === '' || str === null) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    };

    Vue.prototype.$isWeixin = function() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    };

    Vue.prototype.$getIsWxMiniProgram = function() {
      return new Promise((resolve) => {
        if (window.__wxjs_environment === 'miniprogram') {
          resolve(true)
        } else {
          window.wx.miniProgram.getEnv(function(res) {
            resolve(res.miniprogram)
          })
          setTimeout(() => {
            resolve(false)
          }, 500)
        }
      })
    }
  },
};
